import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { optimumPlan } from "../../utils/constants";
import {
  fetchFilteredMobile,
  fetchLocation,
  fetchOptimumDropdown,
  fetchOrderPrice,
} from "../../services/services";

// Async thunk for login
export const dashboardAsync = createAsyncThunk("dashboard/login", async () => {
  const response = await fetchOptimumDropdown();
  if (response.status) {
    throw new Error(response.message); // Explicitly throw the error
  }
  return response;
});

export const fetchStateLocation = createAsyncThunk(
  "dashboard/fetchState",
  async ({ zipcode }) => {
    const response = await fetchLocation(zipcode);
    if (response.status) {
      throw new Error(response.message); // Explicitly throw the error
    }
    return response;
  }
);

export const calculateOrders = createAsyncThunk(
  "dashboard/calculeOrderPrice",
  async ({ details }) => {
    const response = await fetchOrderPrice(details);
    if (response.status) {
      throw new Error(response.message); // Explicitly throw the error
    }
    return response;
  }
);

export const filterMobileDevice = createAsyncThunk(
  "dashboard/filterMobileDevice",
  async ({ details }) => {
    const response = await fetchFilteredMobile(details);
    if (response.status) {
      throw new Error(response.message); // Explicitly throw the error
    }
    return response;
  }
);

const initialState = {
  dashboardData: [],
  orderPrice: null,
  filteredMobileDevice: [],
  zipcode: null,
  loading: true,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    clearOrderPrice: (state, payload) => {
      state.orderPrice = null;
    },
    clearMobileFilter: (state, payload) => {
      state.filteredMobileDevice = null;
    },
  },
  extraReducers: (builder) => {
    // Login reducers
    builder
      .addCase(dashboardAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(dashboardAsync.fulfilled, (state, action) => {
        state.dashboardData = action.payload;
        state.loading = false;
      })
      .addCase(dashboardAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchStateLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStateLocation.fulfilled, (state, action) => {
        state.zipcode = action.payload;
        state.loading = false;
      })
      .addCase(fetchStateLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(calculateOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(calculateOrders.fulfilled, (state, action) => {
        state.orderPrice = action.payload;
        state.loading = false;
      })
      .addCase(calculateOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(filterMobileDevice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(filterMobileDevice.fulfilled, (state, action) => {
        state.filteredMobileDevice = action.payload;
        state.loading = false;
      })
      .addCase(filterMobileDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearOrderPrice, clearMobileFilter } = dashboardSlice.actions;

export default dashboardSlice.reducer;
